import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";

import CollectionRequestsTable from "../../components/CollectionRequests/CollectionRequestsTable";





const CollectionRequestPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Collection Requests" />

        <CollectionRequestsTable />

      </MasterLayout>
    </>
  );
};

export default CollectionRequestPage;
